var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgFlange = function SvgFlange(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 40h3V8h-3v32Zm-2-9.57v2.14h-3c-.55 0-1 .45-1 1V38c0 .55.45 1 1 1h3v2c0 .55.45 1 1 1h10c.55 0 1-.45 1-1v-2h3c.55 0 1-.45 1-1v-4.43c0-.55-.45-1-1-1h-3v-2.14h8V32c0 .55.45 1 1 1h5c.55 0 1-.45 1-1V16c0-.55-.45-1-1-1h-5c-.55 0-1 .45-1 1v1.57h-8V15.6h3c.55 0 1-.45 1-1v-4.43c0-.55-.45-1-1-1h-3V7c0-.55-.45-1-1-1H19c-.55 0-1 .45-1 1v2.17h-3c-.55 0-1 .45-1 1v4.43c0 .55.45 1 1 1h3v1.97h-8V16c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v16c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-1.57h8Zm0-2v-8.86h-8v8.86h8Zm-10 1V17H5v14h3v-1.57Zm8 5.14h2V37h-2v-2.43Zm14 0V37h2v-2.43h-2Zm-2-1V8h-3v32h3v-6.43Zm-12-22.4h2v2.43h-2v-2.43Zm14 0v2.43h2v-2.43h-2Zm8 8.4v8.86h-8v-8.86h8ZM40 31V17h3v14h-3Z"
  })));
};

export default SvgFlange;